import styled from "styled-components";
import { Colors } from "../../../../values/colors";

export const Anchor = styled.div`
  position: relative;
  width: 110px;
  height: 40px;
  flex-shrink: 0;
`;

export const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
  width: 110px;
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color .2s, width .25s, height .25s, border-radius .2s;
  z-index: 5;

  .fake-button {
    display: inline-flex;
    align-items: center;
    padding: 0 16px;
    white-space: nowrap;
    .icon {
      margin-right: 8px;
    }
    .icon path {
      transition: fill 0.2s;
    }
  }

  &.open {
    position: fixed;
    flex-direction: column;
    align-items: stretch;
    cursor: auto;
    background-color: #fff;
    width: 540px;
    max-width: calc(100vw - 32px);
    height: auto;
    max-height: 80vh;
    overflow-y: auto;
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.18);
    padding: 1.5rem;
    z-index: 200;

    .top {
      width: 100%;
      padding-bottom: 1rem;
      border-bottom: 1px solid #eee;
    }
    .fake-button {
      padding: 0;

      .title {
        color: ${Colors.primary};
      }
      .icon path {
        fill: ${Colors.primary};
      }
    }

    .filter-body {
      margin-top: 1rem;
    }
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 150;
`;

export const StretchedContainer = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  min-width: 130px;
`;

export const Content = styled.div`
  width: 100%;
`;

export const Select = styled.select`
  width: 100%;
  margin-top: 10px;
  padding: 9px 10px;
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 6px;
  font-size: 13px;
  color: ${Colors.blueGray};
  background: #fff;
  outline: none;
  cursor: pointer;

  &:disabled {
    background: ${Colors.ultraLightGray3};
    color: ${Colors.lightGray};
    cursor: not-allowed;
  }

  &:focus {
    border-color: ${Colors.primary};
  }
`;
